<template>
    <div class="page-box" :style="{backgroundImage: `url(${imgBg})` }">
      <com-header />
      <div class="menu-content">
        <div class="page-box-scroll">
          <div class="brand-list">
            <div class="brand-list-item" v-for="item in imgList" @click="getDetails(item.id)">
              <img :src="item.cover_image" alt="">
<!--              <el-image-->
<!--                :src="item.cover_image"-->
<!--                :preview-src-list="getHandleImg(imgList)">-->
<!--              </el-image>-->
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: "brand",
  data(){
    return {
      navDrawer: false,
      imgList: [],
      shopInfo:{},
      imgBg:''
    }
  },
  mounted() {
    this.getImgList({id: this.$route.query.id })
    this.shopInfo =  JSON.parse(localStorage.getItem('shopInfo')) || {}
    this.getImgBg({id: this.$route.query.id })
  },
  methods: {
    getImgBg(params) {
      this.$get('/pc/shop/bgimg', params).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    getHandleImg(data) {
      if (data.length > 0) {
        let arr = data.map((item) => {
          return item = item.img
        })
        return arr
      }
      return []
    },
    getImgList(params) {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass:'el-loading-com'
      });
      this.$get('/pc/shop/categoryCustomer',params).then((res) => {
        loading.close();
        this.imgList = [...this.imgList, ...res.data]
      }).catch((error) => {
        loading.close();
      })
    },
    getDetails(id) {
      this.$router.push(`brandDetails?id=${id}`)
    }

  }

}
</script>

<style scoped lang="less">
.page-box {
  height: 100vh;
  background-size: cover;
}
.brand-list {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: calc(100vw - 160px);
  height: 100%;
  margin: 0 80px;
  box-sizing: border-box;
}
.brand-list-item{
  width: 15.52vw;
  height: 27.6vw;
  margin-left: 10px;
  .el-image {
    width: 15.52vw;
    height: 27.6vw;
    >img {
      width: 100%;
      height: 100%;
    }
  }
  img{
    width: 15.52vw;
    height: 27.6vw;
  }

}
.brand-list-item:hover{
  margin-top: -20px;
}

</style>



// WEBPACK FOOTER //
// src/views/brand.vue